import React, { FC, useState } from "react";
import { HomeHeaderWithContext } from "./HomeHeader";
import { HomeWebmapsWithContext } from "./HomeWebmaps";
import { HomeAdministrationWithContext } from "./HomeAdministration";
import { Grid } from "@mui/material";
import EditAccount from "./Forms/EditAccount";

type MainMenuProps = {
  onWebMapOpenClick?: (willRedirectToSameHost: boolean) => void;
};

/**
 * Wraps the main user area consisting of header with name and role, webmaps dropdown, admin area
 * (optionally) and account editing.
 */
const MainMenu: FC<MainMenuProps> = ({ onWebMapOpenClick }) => {
  const [accountEditMode, setAccountEditMode] = useState<boolean>(false);

  if (accountEditMode) {
    return (
      <Grid
        container
        flexDirection="column"
        alignItems="center"
        spacing={0.5}
        sx={{ pt: 1, mb: 0.5 }}
      >
        <EditAccount onFinish={() => setAccountEditMode(false)} />
      </Grid>
    );
  }

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      spacing={0.5}
      sx={{ pt: 1 }}
    >
      <HomeHeaderWithContext />
      <HomeWebmapsWithContext onOpenClick={onWebMapOpenClick} />
      <HomeAdministrationWithContext
        onEditAccountClick={() => {
          setAccountEditMode(true);
        }}
      />
    </Grid>
  );
};

export default MainMenu;
